// extracted by mini-css-extract-plugin
var _1 = "WidgetHeaderContentTitle-moduleWidgetHeaderContentTitle__DV1nU";
export { _1 as "WidgetHeaderContentTitle" }
